var React = require('react');

function RubleSign (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M320 368v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M239.36 32H76a12 12 0 0 0-12 12v206.63H12a12 12 0 0 0-12 12V308a12 12 0 0 0 12 12h52v148a12 12 0 0 0 12 12h58.56a12 12 0 0 0 12-12V320h92.8C324.48 320 384 260.54 384 175.07S324.48 32 239.36 32zM224 250.63h-77.44V100.75h78.72c46.72 0 74.88 29.11 74.88 74.32 0 45.83-28.16 75.56-76.16 75.56z","className":"fa-primary","key":2})]);
}

RubleSign.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = RubleSign;

RubleSign.default = RubleSign;
